import type { FaireProductEntity } from "../../entity_types/product";

export const p_r7a8m6xxpj: FaireProductEntity = {
  token: "p_r7a8m6xxpj",
  type: "product",
  name: "De La Rosa Mazapan Original 30ct",
  brandToken: "b_6w2wcf7tpu",
  brandName: "Mr. YuYu's Chililicious Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/f8e4e24053ac8a15e441cc8b6387b4dda24231b2c097e32747e936c3247008db.jpeg",
  galleryImageUrls: [],
  priceDollars: 0.42,
  description:
    "De La Rosa Mazapan Original 30ct 30 Count delivers a traditional Mexican confection with a rich almond flavor and crumbly texture. Each piece provides 3 grams of protein, offering a satisfying and indulgent snack option. Packaged in a 30-count set, this product is ideal for wholesale distribution, retail shelves, and convenience stores, providing accessibility and strong consumer appeal for sharing or individual enjoyment.\n\nKey Features\n\n * \n30-count pack optimized for wholesale distribution\n\n * \nRich almond flavor with authentic crumbly texture\n\n * \nEach piece provides 3 grams of protein\n\n * \nConvenient packaging suitable for sharing or on-the-go\n\n * \nIdeal for retail, convenience stores, and specialty food markets\n",
  tags: [],
  msrpDollars: 0.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:18.598Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
